import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { OrderInvoiceStatusService } from './Service/order-invoice-status.service';
import { ChaseOrderInvoiceProcessInput } from './Model/ChaseOrderInvoiceProcessInput';
import { ChaseOrderInvoiceProcessOutput } from './Model/ChaseOrderInvoiceProcessOutput';

@Component({
    selector: 'app-order-invoice-status',
    templateUrl: './order-invoice-status.component.html',
    styleUrls: ['./order-invoice-status.component.css'],
    providers: [OrderInvoiceStatusService],
    standalone: false
})
export class OrderInvoiceStatusComponent implements OnInit {

  constructor(private location: Location, private router: Router, private orderInvoiceStatusService: OrderInvoiceStatusService) { }

  uId: string;
  status: string;

  transactionStatus: ChaseOrderInvoiceProcessOutput = new ChaseOrderInvoiceProcessOutput();

  ngOnInit() {

    this.location.subscribe(change => {
      if(change.type === "popstate")
        this.router.navigate(['Invoice', 'order']);
    });

    this.uId = this.router.parseUrl(this.router.url).queryParams['uId'];
    this.orderInvoiceStatusService.getTransactionStatusFromUID(this.uId).subscribe(
      (p: ChaseOrderInvoiceProcessOutput) => {
        // debugger;
        this.transactionStatus = p;
        if (this.transactionStatus.transactionStatus === 'Success') {
          this.status = 'Success';
        } else {
          this.status = 'Failure';
        }
      });

  }

  home() {
    this.router.navigate(['Invoice', 'order']);
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>MediaPay - Invoice Payment</title>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );

    let btn = popupWin.document.getElementById('goToHome');
    btn.parentNode.removeChild(btn);
    popupWin.document.close();
  }


}
